// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__Ng5Px g-grid","videoWrapper":"style_videoWrapper__ghPab"};